import { Controller } from "@hotwired/stimulus"

// The skeleton follows the actual Turbo request, never a simulated progress timer.
export default class extends Controller {
  static targets = ["form", "loading", "recovery"]
  static values = { auto: Boolean }

  connect() {
    if (this.autoValue && !document.documentElement.hasAttribute("data-turbo-preview")) {
      this.frame = requestAnimationFrame(() => this.formTarget.requestSubmit())
    }
  }

  disconnect() { cancelAnimationFrame(this.frame) }

  start() {
    this.loadingTarget.hidden = false
    this.recoveryTarget.hidden = true
    this.element.setAttribute("aria-busy", "true")
  }

  finish({ detail }) {
    if (detail.success) return
    this.loadingTarget.hidden = true
    this.recoveryTarget.hidden = false
    this.element.removeAttribute("aria-busy")
  }
}
